// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"bf3e209a","207":"e234b133","239":"30d45bd6","396":"46641fc7","411":"865006c3","455":"384b8d82","679":"aca18fac","977":"4bdbbbb7"}[chunkId] + ".chunk.js";
};